export default __webpack_public_path__ + "static/media/home-elder-care-icon.4976e8ef.svg";